import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  backgroundColor,
  contentPageNameColor,
  contentPageSummaryColor,
  moduleText,
  subtitleColor,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const Text = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('general.backgroundColour')}>
        <Field name={[moduleText, backgroundColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.subtitleColour')}>
        <Field name={[moduleText, subtitleColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.contentPageNameColour')}>
        <Field name={[moduleText, contentPageNameColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.contentPageSummaryColour')}>
        <Field name={[moduleText, contentPageSummaryColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default Text;
